const endpoints = {
  // Auth
  auth: {
    login: 'auth/token',
    loginOAuth: (providerId) => `auth/token/${providerId}`,
    refreshToken: 'auth/refreshtoken',
    resetPassword: 'auth/password',
    requestPasswordReset: 'auth/password/request',
  },

  // Self
  self: {
    _: '/self',
    affiliates: '/self/affiliates',
    address: '/self/address',
    password: '/self/password',
    orders: '/self/orders',
    discount: '/self/discount',
    order: (id) => ({
      _: `/self/orders/${id}`,
      address: `/self/orders/${id}/address`,
      deliveryDate: `/self/orders/${id}/delivery-date`,
      additionalExtras: (extraId) => `/self/orders/${id}/additional-extras/${extraId}`,
    }),
    dogs: {
      _: '/self/dogs',
    },
    dog: (id) => ({
      _: `/self/dogs/${id}`,
      recommendedPlan: `/self/dogs/${id}/recommended-plan`,
      avatar: `/self/dogs/${id}/avatar`,
    }),
    subscription: {
      paymentMethod: '/self/subscription/payment-method',
      coupon: '/self/subscription/coupon',
      status: '/self/subscription/status',
      cycle: '/self/subscription/cycle',
      bagsPerOrder: (g, orders) => `/self/subscription/bags?dailyGrams=${g}&ordersInCycle=${orders}`,
      deliveryCompany: 'self/subscription/delivery-company',
      extra: (id) => ({
        _: `/self/subscription/extras/${id}`,
      }),
      plan: '/self/subscription/plan',
      planAlternatives: '/self/subscription/plan-alternatives',
    },
    quotation: '/self/quotation',
    gramsToPrice: '/self/grams-to-price',
    nutritionistsMessage: '/self/nutritionists-message',
    notifications: {
      push: {
        send: '/self/notifications/push/messages',
        register: '/self/notifications/push/browser-token',
      },
    },
    engagementHistory: '/self/engagement-history',
  },

  // Leads
  leads: {
    _: '/leads',
    simplified: '/leads/simplified',
  },
  lead: (id) => ({
    _: `/leads/${id}`,
    customers: `/leads/${id}/customers`,
    coupon: `/leads/${id}/coupon`,
    planAlternatives: `/leads/${id}/plan-alternatives`,
    acquisition: `/leads/${id}/acquisition`,
  }),

  // Config
  config: {
    deliveryDateAvailability: '/config/delivery-date-availability',
    noDeliveryDates: '/config/no-delivery-dates',
    availableDeliveryDates: '/config/available-delivery-dates',
    firstAvailableDeliveryDate: '/config/first-available-delivery-date',
    breedStats: '/config/breed-stats',
    campaigns: '/config/campaigns',
    extrasAvailability: (country) => `/config/extras-availability?country=${country}`,
    menusMonthlyStats: '/config/menu-stats',
    mailingPreferences: (userId) => `/config/mailing-preferences/${userId}`,
    geocontext: (ip = '') => `/config/geocontext/${ip}`,
  },

  // Coupons
  coupons: {
    active: (code) => `/coupons/active/${code}`,
  },

  // Validations
  validations: {
    referral: (code) => `/validations/referral/${code}`,
  },

  // Third party API endpoints
  geoContext: (ip) => `https://api.ipdata.co/${ip}`,
}

export default endpoints
